<template>
    <app-data-table :fields="fields" :items="data">
        <template slot="index" slot-scope="{ item, row }">{{ row + 1 }}</template>

        <template slot="photo_url" slot-scope="data">
            <b-button
                size="sm"
                v-if="!data.item.detailsShowing"
                :disabled="!data.item.photo_url"
                @click.stop="data.toggleDetails"
                variant="primary"
            >Foto</b-button>
            <b-button size="sm" v-else variant="danger" @click.stop="data.toggleDetails">Cerrar</b-button>
        </template>

        <template slot="row-details" slot-scope="data">
            <div class="d-flex justify-content-center">
                <div class="w-50">
                    <b-img :src="data.item.photo_url" fluid></b-img>
                </div>
            </div>
        </template>

        <template slot="created_at" slot-scope="{ item }">{{ item.created_at | datetime }}</template>

        <template v-if="seeActions" slot="actions" slot-scope="{ item }">
            <b-button
                size="sm"
                variant="danger"
                title="Eliminar punto de control"
                @click="removeCheckpoint(item)"
            >
                <i class="fa fa-trash"></i>
            </b-button>
        </template>
    </app-data-table>
</template>
<script>
import fields from './fields'
export default {
    props: {
        data: {
            type: Array,
        },
        seeActions: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            fields,
        }
    },
    computed: {
        checkpoints() {
            return this.data.sort((a, b) => a.created_at - b.created_at)
        },
    },
    methods: {
        removeCheckpoint(data) {
            this.$emit('remove-service', data)
        },
        onChangePage(page) {
            this.$emit('change-page', page)
        },
    },
}
</script>